import { Injectable } from '@angular/core';
import { CookieService } from 'src/sb-tools/typescript/authentication/cookie.service';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';
import { HelperService } from 'src/sb-tools/typescript/services/helper.service';

const WEEK_IN_MS = 604800000;

@Injectable({
    providedIn: 'root',
})
export class MessageStorageService {
    formId: number;
    replyId: number;
    ticketId: number;

    private timer;

    constructor(
        private cookieService: CookieService,
        private windowRef: WindowRef,
    ) {}

    clearDraft(isForwardMessage: boolean) {
        const currentKey = this.getDraftKey(isForwardMessage);

        if (HelperService.isLocalStorageNameSupported()) {
            this.windowRef.nativeWindow.localStorage.removeItem(currentKey);
        } else {
            this.cookieService.deleteCookie(currentKey);
        }
    }

    getDraftFromStorage(isForwardMessage: boolean) {
        const currentKey = this.getDraftKey(isForwardMessage);
        let data;

        if (HelperService.isLocalStorageNameSupported()) {
            data = this.windowRef.nativeWindow.localStorage.getItem(currentKey);
        } else {
            data = this.cookieService.getCookie(currentKey);
        }

        if (data) {
            try {
                return JSON.parse(data);
            } catch {
                return null;
            }
        }
    }

    getDraftMessage(isForwardMessage: boolean): string {
        const draft = this.getDraftFromStorage(isForwardMessage);

        if (draft) {
            const isExpiredDraft = new Date().getTime() - draft.changeDate >= WEEK_IN_MS;

            if (isExpiredDraft) {
                this.clearDraft(isForwardMessage);
            } else {
                return draft.html;
            }
        }
    }

    updateDraftMessage(draftText: string, isForwardMessage: boolean) {
        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.timer = setTimeout(() => {
            if (this.isMessageTextEmpty(draftText)) {
                this.clearDraft(isForwardMessage);
            } else {
                this.saveDraftMessage(draftText, isForwardMessage);
            }
        }, 300);
    }

    private getDraftKey(isForwardMessage: boolean) {
        if (isForwardMessage) {
            return 'forwardMessageForTicket' + this.ticketId + (this.replyId ? 'Reply' + this.replyId : '');
        } else {
            return 'newTicketMessage' + this.formId;
        }
    }

    private isMessageTextEmpty(draftText): boolean {
        return !HelperService.strip(draftText).trim();
    }

    private saveDraftMessage(draftText: string, isForwardMessage: boolean) {
        const currentKey = this.getDraftKey(isForwardMessage);
        const draft = JSON.stringify({
            changeDate: new Date().getTime(),
            html: draftText,
        });

        if (HelperService.isLocalStorageNameSupported()) {
            this.windowRef.nativeWindow.localStorage.setItem(currentKey, draft);
        } else {
            this.cookieService.setCookie(currentKey, draft);
        }
    }
}
